// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"3afacec7","703":"8cbded2b"}[chunkId] + ".chunk.js";
};